<div class="header-profile" data-content="profile">
  <div class="header-profile-content">
    <div class="header-profile-profile-picture" [style.background-image]="'url(' + (imageUrl || placeholderImageUrl) + ')'"></div>

    <div class="profile-informations">
      <h1 [appDataCSmask]="maskPii" class="profile-informations-name rc-title-alpha" [innerHTML]="headerTitle | safeHtml"></h1>

      @if (attributes) {
        <ul class="profile-informations-list">
          @for (attr of attributes; track attr.id) {
            <li class="profile-informations-list-item">
              <p class="profile-informations-list-item-title">
                {{ attr.label }}
              </p>
              <p class="profile-informations-list-item-value">
                <app-rc-attribute
                  [object]="object"
                  [attribute]="attr"
                  [currentSystemPreferenceCode]="currentSystemPreferenceCode"
                  [weightUnit]="currentBigMeasurementUnit"
                  [maskPii]="maskPii"
                ></app-rc-attribute>
              </p>
            </li>
          }
        </ul>
      }
    </div>

    <ng-content select="[right]"></ng-content>
  </div>
</div>
